export const podcasts = [
    {
    "id": 34,
    "name": "Access to STEM Education",
    "short_name": "access_stem_education",
    "priority": 1,
    "type": "video",
    "description": "Listen to Rasha El Nossery, Architect and mother, who wanted to see more STEM education opportunities for her children and others in her community and from there she designed a solution to create a mobile STEM lab.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Access+to+STEM+Education/Design+for+Change+USA+-+Podcast+-+Access+to+STEM+Education++-+Picture.png",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Access+to+STEM+Education/Design+for+Change+USA+-+Podcast+-+Access+to+STEM+Education++-+Picture.png",
    "published": 1644246404,
    "duration": "11 minutes",
    "difficulty": "Advanced",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_4.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://vimeo.com/674463426",
    "visuals": "",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Access+to+STEM+Education/Design+for+Change+USA+-+Podcast+-+Access+to+STEM+Education++-+Transcript.json"
    },
    {
    "id": 33,
    "name": "STEM Gender Equity",
    "short_name": "stem_gender_equity",
    "priority": 0,
    "type": "video",
    "description": "Inspiration Podcast: Hear from youth and teachers who are tackling the gender gap in STEM professions, despite the growing number of women in STEM majors and careers.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/STEM+Gender+Equity/Design+for+Change+USA+-+Podcast+-+STEM+Gender+Equity+-+Picture.png",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/STEM+Gender+Equity/Design+for+Change+USA+-+Podcast+-+STEM+Gender+Equity+-+Picture+-+Large.png",
    "published": 1636339587,
    "duration": "14 minutes",
    "difficulty": "Intermediate",
    "course": "equity",
    "global_goal": "Gender Equity",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_5.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://vimeo.com/643340203",
    "visuals": "",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/STEM+Gender+Equity/Design+for+Change+USA+-+Podcast+-+STEM+Gender+Equity+-+Transcript.json"
    },
    {
    "id": 32,
    "name": "Transgender Identity",
    "short_name": "transgender_identity",
    "priority": 0,
    "type": "video",
    "description": "Listen to Oliver share stories about her experience as a transgender student in elementary school, and the valuable lessons from her family about what we all can do to better support the transgender community.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Transgender+Identity/Design+for+Change+USA+-+Podcast+-+Transgender+Identity+-+Picture.png",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Transgender+Identity/Design+for+Change+USA+-+Podcast+-+Transgender+Identity+-+Picture+-+Large.png",
    "published": 1628626119,
    "duration": "22 minutes",
    "difficulty": "Intermediate",
    "course": "justice",
    "global_goal": "Reduce Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "//pm.designforchange.us/img/partners/logo_hasbro.png",
    "sponsor_name": "Hasbro",
    "sponsor_url": "https://shop.hasbro.com/en-us/bring-home-the-fun",
    "url": "https://vimeo.com/585510743",
    "visuals": "",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Transgender+Identity/Design+for+Change+USA+-+Podcast+-+Transgender+Identity+-+Transcript.json"
    },
    {
    "id": 31,
    "name": "LGBTQ+ Youth Activism",
    "short_name": "gender_equity",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Hear the powerful stories of LGBTQ youth and what they Wish You Knew about their lives and experiences, and the role society plays in shaping how we see ourselves and each other.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Gender+Equity/Design+for+Change+USA+-+Podcast+-+Gender+Equity+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Gender+Equity/Design+for+Change+USA+-+Podcast+-+Gender+Equity+-+Picture+-+Large.jpg",
    "published": 1624022810,
    "duration": "12 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Reduce Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Gender+Equity/Design+for+Change+USA+-+Podcast+-+Gender+Equity+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/16qrG3brVCXdYnS7S4sSvlBnvzXf1IvM-taleE6O864I/pub?start=false&loop=false&delayms=60000&slide=id.p1",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Gender+Equity/Design+for+Change+USA+-+Podcast+-+Gender+Equity+-+Transcript.json"
    },
    {
    "id": 30,
    "name": "Discrimination and Hate Towards the AAPI Community",
    "short_name": "aapi",
    "priority": 0,
    "type": "audio",
    "description": "Explore the ways students have been impacted by hateful rhetoric and racist actions targeted at the AAPI community",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Discrimination+Against+the+AAPI+Community/Design+for+Change+USA+-+Podcast+-+Discrimination+Against+the++AAPI+Community+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Discrimination+Against+the+AAPI+Community/Design+for+Change+USA+-+Podcast+-+Discrimination+Against+the++AAPI+Community+-+Picture+-+Large.jpg",
    "published": 1620236656,
    "duration": "12 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Sustainable Cities and Communities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_11.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Discrimination+Against+the+AAPI+Community/Design+for+Change+USA+-+Podcast+-+Discrimination+Against+the+AAPI+Community+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSMbXylI4O0Y1VYaN6J7SQ2-IhnEFlzMssS2p_kAd79YWIaUBbXug7jIj2CFNeQHTq3vHD8CXMB17yT/pub?start=false&loop=false&delayms=60000&slide=id.p1",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Discrimination+Against+the+AAPI+Community/Design+for+Change+USA+-+Podcast+-+Discrimination+Against+the+AAPI+Community+-+Transcript.json"
    },
    {
    "id": 29,
    "name": "Voting",
    "short_name": "voting",
    "priority": 0,
    "type": "audio",
    "description": "Explore ways in which other youth are engaging civically and promoting the voting process.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Voting/Design+for+Change+USA+-+Podcast+-+Voting+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Voting/Design+for+Change+USA+-+Podcast+-+Voting+-+Picture+-+Large.jpg",
    "published": 1603477880,
    "duration": "9 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Sustainable Cities and Communities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_11.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Voting/Design+for+Change+USA+-+Podcast+-+Voting+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSAJr4ua42epnyjo3a3HkyhQMagmdFAmbgGA8pR0J3JZy29dgy1P4FWWD8gH4OY_m8MOeYBJ2eXasfa/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Voting/Design+for+Change+USA+-+Podcast+-+Voting+-+Transcript.json"
    },
    {
    "id": 15,
    "name": "#DoGoodFromHome",
    "short_name": "dogoodfromhome",
    "priority": 0,
    "type": "audio",
    "description": "Explore the impact of the sudden changes brought on by COVID-19 and the way others are doing good from home.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/DoGoodFromHome/Design+for+Change+USA+-+Podcast+-+%23DoGoodFromHome+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/DoGoodFromHome/Design+for+Change+USA+-+Podcast+-+%23DoGoodFromHome+-+Picture+-+Large.jpg",
    "published": 1585679981,
    "duration": "8 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Partnerships for the Goals",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_17.png",
    "sponsor_logo": "//pm.designforchange.us/img/partners/logo_hasbro.png",
    "sponsor_name": "Hasbro",
    "sponsor_url": "https://shop.hasbro.com/en-us/bring-home-the-fun",
    "url": "https://dfc-podcasts.s3.amazonaws.com/DoGoodFromHome/Design+for+Change+USA+-+Podcast+-+%23DoGoodFromHome+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSeyfAEXlw5C39gfwh1mYbLFg0Z62wWSbDx-EKV30_htdmIu9FCO0cygqkJBVe4TycsJN3MT1AcGxda/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/DoGoodFromHome/Design+for+Change+USA+-+Podcast+-+%23DoGoodFromHome+-+Transcript.json"
    },
    {
    "id": 19,
    "name": "Compassion During Coronavirus",
    "short_name": "coronaviruscompassion",
    "priority": 0,
    "type": "audio",
    "description": "Explore the ways others are affected by crisis while making meaning of personal experiences. Note: This podcast can be a companion to any in the COVID-19 series.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Compassion+During+Coronavirus/Design+for+Change+USA+-+Podcast+-+Compassion+During+Coronavirus+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Compassion+During+Coronavirus/Design+for+Change+USA+-+Podcast+-+Compassion+During+Coronavirus+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Partnerships for the Goals",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_17.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Compassion+During+Coronavirus/Design+for+Change+USA+-+Podcast+-+Compassion+During+Coronavirus+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vT8P04AA_BBQ8w8XTsPY_evOh91fN0ei_EusO-_69cadJbpn6Ic5bawPTkFVvrk5L6STFX7FMKOAjOo/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Compassion+During+Coronavirus/Design+for+Change+USA+-+Podcast+-+Compassion+During+Coronavirus+-+Transcript.json"
    },
    {
    "id": 20,
    "name": "Local Climate Action",
    "short_name": "climateaction",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Learn from youth changemakers who are taking steps towards impacting their local environment. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Local+Climate+Action/Design+for+Change+USA+-+Podcast+-+Local+Climate+Action+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Local+Climate+Action/Design+for+Change+USA+-+Podcast+-+Local+Climate+Action+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Climate Action",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_13.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Local+Climate+Action/Design+for+Change+USA+-+Podcast+-+Local+Climate+Action+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTSHs2bH5WupTtLG1z5LF8YNcrRbQZZd7_YsPiEDoyeV6mu9BwbOLkgUhph7yf3au0WbwpOHOvgRiyM/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Local+Climate+Action/Design+for+Change+USA+-+Podcast+-+Local+Climate+Action+-+Transcript.json"
    },
    {
    "id": 21,
    "name": "Digital Changemaking",
    "short_name": "digital_changemaking",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Learn from youth changemakers who are leveraging technology to make an impact across a variety of social causes.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Digital+Changemaking/Design+for+Change+USA+-+Podcast+-+Digital+Changemaking+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Digital+Changemaking/Design+for+Change+USA+-+Podcast+-+Digital+Changemaking+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Intermediate",
    "course": "education",
    "global_goal": "Partnerships for the Goals",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_17.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Digital+Changemaking/Design+for+Change+USA+-+Podcast+-+Digital+Changemaking+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSdKPtyz82u1FXGU-jfh13x-p53VeYKcebjSRY684TWKMorN2MwtLah4hQ9iY6nIMX2a_2zz_pDqgsa/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Digital+Changemaking/Design+for+Change+USA+-+Podcast+-+Digital+Changemaking+-+Transcript.json"
    },
    {
    "id": 22,
    "name": "Access to Menstrual Products",
    "short_name": "menstrual_products",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Learn from youth changemakers and their adult advocates who are working to ensure equal access to menstrual products. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Access+to+Menstrual+Products/Design+for+Change+USA+-+Podcast+-+Access+to+Menstrual+Products+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Access+to+Menstrual+Products/Design+for+Change+USA+-+Podcast+-+Access+to+Menstrual+Products+-+Large+Picture.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Intermediate",
    "course": "education",
    "global_goal": "Gender Equality",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_5.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Access+to+Menstrual+Products/Design+for+Change+USA+-+Podcast+-+Access+to+Menstrual+Products+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vS5OCeXBd5OlMj5mFW13zH-sIo27IbG1FYoeE2E7bg6wtcl10SurPP1-LMn2e_qiTEloNXyXodE61zO/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Access+to+Menstrual+Products/Design+for+Change+USA+-+Podcast+-+Access+to+Menstrual+Products+-+Transcript.json"
    },
    {
    "id": 23,
    "name": "COVID-19: Student Reflections",
    "short_name": "covid19_reflections",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Listen and reflect alongside young people as they consider the real impact of COVID-19 pandemic on their experience of school. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/COVID-19+-+Student+Reflection/Design+for+Change+USA+-+Podcast+-+COVID-19+Student+Reflections+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/COVID-19+-+Student+Reflection/Design+for+Change+USA+-+Podcast+-+COVID-19+Student+Reflections+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "10 minutes",
    "difficulty": "Intermediate",
    "course": "education",
    "global_goal": "Quality Education",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_4.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/COVID-19+-+Student+Reflection/Design+for+Change+USA+-+Podcast+-+COVID-19+Student+Reflections+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSzOBghth2HegNCIEhA-t0pp51bQIZ832g1a6nHeQBcrk1Fk2FH0VXxjkQHpEAxXvKsmv-2THNePO-g/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/COVID-19+-+Student+Reflection/Design+for+Change+USA+-+Podcast+-+COVID-19_+Student+Reflections+-+Transcript.json"
    },
    {
    "id": 24,
    "name": "Combating Racism: Black Youth Leadership",
    "short_name": "combating_racism_byl",
    "priority": 0,
    "type": "audio",
    "description": "Explore the ways specific events exacerbate issues of racism and spark concrete action towards racial justice.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Black+Youth+Leadership/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Black+Youth+Leadership+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Black+Youth+Leadership/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Black+Youth+Leadership+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "11 minutes",
    "difficulty": "Advanced",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Black+Youth+Leadership/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Black+Youth+Leadership+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSIOo59Jpn4c5plPoL4wJIqSIfP8fckeLinsM-GEUl6ISWGhYsFvjnOik2Tn-YAUqZYvJGVfyx4SddF/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Black+Youth+Leadership/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Black+Youth+Leadership+-+Transcript.json"
    },
    {
    "id": 25,
    "name": "Racism: Black Youth Perspectives",
    "short_name": "racism_byp",
    "priority": 0,
    "type": "audio",
    "description": "Consider the ways issues of racism and inequity impact the experiences of Black youth across the country. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Racism+-+Black+Youth+Perspectives/Design+for+Change+USA+-+Podcast+-+Racism+-+Black+Youth+Perspectives+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Racism+-+Black+Youth+Perspectives/Design+for+Change+USA+-+Podcast+-+Racism+-+Black+Youth+Perspectives+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Advanced",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Racism+-+Black+Youth+Perspectives/Design+for+Change+USA+-+Podcast+-+Racism+-+Black+Youth+Perspectives+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTpH-NtaelRcH0JfC5NGnA8GsnTndWJuc2rq1ogW_mHIORNMBN_VnRcytxsvY886feBh62Arz2ORd4s/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Racism+-+Black+Youth+Perspectives/Design+for+Change+USA+-+Podcast+-+Racism+-+Black+Youth+Perspectives+-+Transcript.json"
    },
    {
    "id": 26,
    "name": "Teaching Accurate History",
    "short_name": "teaching_accurate_history",
    "priority": 0,
    "type": "audio",
    "description": "Explore the feelings around and the consequences of schools failing to teach accurate history, especially around issues of racial justice. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Teaching+Accurate+History/Design+for+Change+USA+-+Podcast+-+Teaching+Accurate+History+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Teaching+Accurate+History/Design+for+Change+USA+-+Podcast+-+Teaching+Accurate+History+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Advanced",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_4.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Teaching+Accurate+History/Design+for+Change+USA+-+Podcast+-+Teaching+Accurate+History+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSRthO6emwmR0igN5MHJqtrIGHQ8aGCnbzI6VwkwU7X8UJdTuY3UCQIymJ7SFMJQ-8782YgP6QkuCX5/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Teaching+Accurate+History/Design+for+Change+USA+-+Podcast+-+Teaching+Accurate+History+-+Transcript.json"
    },
    {
    "id": 27,
    "name": "Food Sustainability in Schools",
    "short_name": "food_sustainability",
    "priority": 0,
    "type": "audio",
    "description": "Inspiration Podcast: Hear from youth taking action to provide local food options to their school community while learning from the experience of gardening. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Food+Sustainability+In+Schools/Design+for+Change+USA+-+Podcast+-+Food+Sustainability+In+Schools+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Food+Sustainability+In+Schools/Design+for+Change+USA+-+Podcast+-+Food+Sustainability+In+Schools+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Sustainable Cities and Communities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_11.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Food+Sustainability+In+Schools/Design+for+Change+USA+-+Podcast+-+Food+Sustainability+In+Schools+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTcMTUMVTUDlBPa9r5XElpExRUt5IiwXgkIIVXDrPxmoPb6ICmqdvfNQgpUv3lLQUEhycwbC3Mf6x6W/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Food+Sustainability+In+Schools/Design+for+Change+USA+-+Podcast+-+Food+Sustainability+In+Schools+-+Transcript.json"
    },
    {
    "id": 28,
    "name": "Combating Racism: Youth Activism",
    "short_name": "combating_racism_youth",
    "priority": 0,
    "type": "audio",
    "description": "Explore youth reactions to and activism around issues of racism. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Youth+Activism/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Youth+Activism+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Youth+Activism/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Youth+Activism+-+Picture+-+Large.jpg",
    "published": 1585679971,
    "duration": "7 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Youth+Activism/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Youth+Activism+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSqZvSYwz_rYW9uK-kR2N-SlAeX6lXS_KhAYgAin8hzYwbhxgdD7BbgTQVMAAUiq322HtpgRDX3EGkB/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Combating+Racism+-+Youth+Activism/Design+for+Change+USA+-+Podcast+-+Combating+Racism+-+Youth+Activism+-+Transcript.json"
    },
    {
    "id": 18,
    "name": "Hygiene and Personal Safety",
    "short_name": "personalsafety",
    "priority": 0,
    "type": "audio",
    "description": "Explore the connection between hygiene and personal safety and their impact on health and well-being. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Hygiene+and+Personal+Safety/Design+for+Change+USA+-+Podcast+-+Hygiene+and+Personal+Safety+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Hygiene+and+Personal+Safety/Design+for+Change+USA+-+Podcast+-+Hygiene+and+Personal+Safety+-+Picture+-+Large.jpg",
    "published": 1585679961,
    "duration": "9 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Good Health and Well-being",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_3.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Hygiene+and+Personal+Safety/Design+for+Change+USA+-+Podcast+-+Hygiene+and+Personal+Safety+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vQQQc6VKguMq6oGPMxtVI3nr29IzpJ20CAfClUBWFlsNBUocTunAQgafuCb8AZot1Qtzs6NSzUk3vHh/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Hygiene+and+Personal+Safety/Design+for+Change+USA+-+Podcast+-+Hygiene+and+Personal+Safety+-+Transcript.json"
    },
    {
    "id": 17,
    "name": "Racialized Discrimination",
    "short_name": "racializeddiscrimination",
    "priority": 0,
    "type": "audio",
    "description": "Explore the impact of racialized discrimination that has manifested as a result of information and misinformation about the COVID-19 pandemic.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Racialized+Discrimination/Design+for+Change+USA+-+Podcast+-+Racialized+Discrimination+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Racialized+Discrimination/Design+for+Change+USA+-+Podcast+-+Racialized+Discrimination+-+Picture+-+Large.jpg",
    "published": 1585679961,
    "duration": "10 minutes",
    "difficulty": "Advanced",
    "course": "justice",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Racialized+Discrimination/Design+for+Change+USA+-+Podcast+-+Racialized+Discrimination+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSLf4AFekh1K620Mk6Ve5IPSiwvzXhuFLtYEcbyA56GahURsjKzgHgRuNxF_lbXDE0BiyMsQQZ3zzj-/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Racialized+Discrimination/Design+for+Change+USA+-+Podcast+-+Racialized+Discrimination+-+Transcript.json"
    },
    {
    "id": 16,
    "name": "Air Quality",
    "short_name": "airquality",
    "priority": 0,
    "type": "audio",
    "description": "Explore the impact of poor air quality on young peoples' experiences and the connection between air quality COVID-19.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Air+Quality/Design+for+Change+USA+-+Podcast+-+Air+Quality+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Air+Quality/Design+for+Change+USA+-+Podcast+-+Air+Quality+-+Picture+-+Large.jpg",
    "published": 1585679961,
    "duration": "9 minutes",
    "difficulty": "Intermediate",
    "course": "climate",
    "global_goal": "Life on Land",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_15.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Air+Quality/Design+for+Change+USA+-+Podcast+-+Air+Quality+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTie48sEwN99fMtisAU3R-NKKnOHkzkbQKQ3SdoQw7HqKYyAAdPnx9K5RCtZqetFClYg_mKpCsNUf9T/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Air+Quality/Design+for+Change+USA+-+Podcast+-+Air+Quality+-+Transcript.json"
    },
    {
    "id": 14,
    "name": "School and Academic Pressures",
    "short_name": "school_pressures",
    "priority": 0,
    "type": "audio",
    "description": "Explore the various reactions to and the impact of experiencing ongoing school and academic pressure.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/School+and+Academic+Pressures/Design+for+Change+USA+-+Podcast+-+School+and+Academic+Pressures+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/School+and+Academic+Pressures/Design+for+Change+USA+-+Podcast+-+School+and+Academic+Pressures+-+Picture+-+Large.jpg",
    "published": 1584230679,
    "duration": "11 minutes",
    "difficulty": "Intermediate",
    "course": "education",
    "global_goal": "Good Health and Well-being",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_3.png",
    "sponsor_logo": "",
    "sponsor_name": "",
    "sponsor_url": "",
    "url": "https://dfc-podcasts.s3.amazonaws.com/School+and+Academic+Pressures/Design+for+Change+USA+-+Podcast+-+School+and+Academic+Pressures+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTE-Jkzio_UKitT1i8ya9Bj1S2fryOOHbXYlAq3iqs1LYHkgCKJdBaqf6xYjtOOly2yxqVANiFdgcaW/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/School+and+Academic+Pressures/Design+for+Change+USA+-+Podcast+-+School+and+Academic+Pressures+-+Transcript.json"
    },
    {
    "id": 1,
    "name": "Food Desert",
    "short_name": "food_desert",
    "priority": 0,
    "type": "audio",
    "description": "Explore the \"Grocery Gap\" and learn more about barriers and consequences that many face in accessing healthy food. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Food+Desert/Design+for+Change+USA+-+Podcast+-+Food+Desert+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Food+Desert/Design+for+Change+USA+-+Podcast+-+Food+Desert+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "9 minutes",
    "difficulty": "Intermediate",
    "course": "justice",
    "global_goal": "Zero Hunger",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_2.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Food+Desert/Design+for+Change+USA+-+Podcast+-+Food+Desert+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vQ9QVwdcHT4P4TS0SlyYUbyFGZEbU1L8BcgORiApZf2n7B1aQFKQdByM9aWQrHAMpYuhmnhOS0LQ8F1/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Food+Desert/Design+for+Change+USA+-+Podcast+-+Food+Desert+-+Transcript.json"
    },
    {
    "id": 13,
    "name": "Plastic Pollution",
    "short_name": "plastic_pollution",
    "priority": 0,
    "type": "audio",
    "description": "Alongside Earth Day Network, explore the causes, the impact and the complicated reality of plastic pollution.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Plastic+Pollution/Design+for+Change+USA+-+Podcast+-+Plastic+Pollution+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Plastic+Pollution/Design+for+Change+USA+-+Podcast+-+Plastic+Pollution+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Intermediate",
    "course": "climate",
    "global_goal": "Climate Action",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_13.png",
    "sponsor_logo": "//pm.designforchange.us/img/partners/logo_earthdaynetwork.png",
    "sponsor_name": "Earth Day Network",
    "sponsor_url": "https://www.earthday.org/",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Plastic+Pollution/Design+for+Change+USA+-+Podcast+-+Plastic+Pollution+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vRf0pJ5LTC8s3dASOXwDmyyrtT318DQxfUFnk5Q2RAhVB_bDHbgltRuVqCs6h81NEB2BrswsSTHL4Ul/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Plastic+Pollution/Design+for+Change+USA+-+Podcast+-+Plastic+Pollution+-+Transcript.json"
    },
    {
    "id": 12,
    "name": "Youth Living with Disabilities",
    "short_name": "youth_disabilities",
    "priority": 0,
    "type": "audio",
    "description": "Explore the instances of inclusion and exclusion that youth living with disabilities describe.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Youth+Living+With+Disabilities/Design+for+Change+USA+-+Podcast+-+Youth+Living+With+Disabilities+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Youth+Living+With+Disabilities/Design+for+Change+USA+-+Podcast+-+Youth+Living+With+Disabilities+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Intermediate",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Youth+Living+With+Disabilities/Design+for+Change+USA+-+Podcast+-+Youth+Living+With+Disabilities+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vRy6UPWeUyvJmXwaxYjOzbtQkEiOLjBV57vXhtLmsHqtu1VtBlVSvshrnsesO_kSwjTJcVfG5luaXYH/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Youth+Living+With+Disabilities/Design+for+Change+USA+-+Podcast+-+Youth+Living+With+Disabilities+-+Transcript.json"
    },
    {
    "id": 11,
    "name": "Cyberbullying",
    "short_name": "cyberbullying",
    "priority": 0,
    "type": "audio",
    "description": "Explore how the internet and social media have influenced the way in which youth experience bullying. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Cyberbullying/Design+for+Change+USA+-+Podcast+-+Cyberbullying+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Cyberbullying/Design+for+Change+USA+-+Podcast+-+Cyberbullying+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Peace, Justice and Strong Institutions",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_16.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Cyberbullying/Design+for+Change+USA+-+Podcast+-+Cyberbullying+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vT0tMotoU_1vxM_94xK2RE_dm-3LolLcFBMKFGtTu9J43yC2p6XdogGoUGXGmSjUmWurelTDD83EBcc/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Cyberbullying/Design+for+Change+USA+-+Podcast+-+Cyberbullying+-+Transcript.json"
    },
    {
    "id": 10,
    "name": "Hijabi Discrimination",
    "short_name": "hijabi_discrimination",
    "priority": 0,
    "type": "audio",
    "description": "Explore the prejudice and discrimination experienced by women who choose to practice hijab in communities across the United States. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Hijabi+Distrimination/Design+for+Change+USA+-+Podcast+-+Hijabi+Discrimination+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Hijabi+Distrimination/Design+for+Change+USA+-+Podcast+-+Hijabi+Discrimination+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Intermediate",
    "course": "justice",
    "global_goal": "Gender Equality",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Hijabi+Distrimination/Design+for+Change+USA+-+Podcast+-+Hijabi+Discrimination+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vStuxDYlZfdMM3WQBk2ceZvkXf6Rg0DR1ut5v9hrDjXUgyiMgNZldg69zTI9wPyfiCF3PWSA3Jnd1LA/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Hijabi+Distrimination/Design+for+Change+USA+-+Podcast+-+Hijabi+Discrimination+-+Transcript.json"
    },
    {
    "id": 9,
    "name": "Mental Health",
    "short_name": "mental_health",
    "priority": 0,
    "type": "audio",
    "description": "Explore the challenges and pressures that can influence the mental health of youth. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Mental+Health/Design+for+Change+USA+-+Podcast+-+Mental+Health+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Mental+Health/Design+for+Change+USA+-+Podcast+-+Mental+Health+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Intermediate",
    "course": "justice",
    "global_goal": "Good Health and Well-being",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_3.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Mental+Health/Design+for+Change+USA+-+Podcast+-+Mental+Health+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTPrxbKCTTnsS3jmkotPs_j-a5bs8nKGPkEbDY-PlHKPGJ0Ff0ertiKa13PDj3gDpwemsBqcbtJn4Ey/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Mental+Health/Design+for+Change+USA+-+Podcast+-+Mental+Health+-+Transcript.json"
    },
    {
    "id": 8,
    "name": "School Community",
    "short_name": "school_community",
    "priority": 0,
    "type": "audio",
    "description": "Explore the realities that a new student might face and how peer support can impact their experience.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/School+Community/Design+for+Change+USA+-+Podcast+-+School+Community+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/School+Community/Design+for+Change+USA+-+Podcast+-+School+Community+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Beginner",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/School+Community/Design+for+Change+USA+-+Podcast+-+School+Community+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vQJQMkWn49S5DjJ34ZiZBZETdLIs-HsOHhOMyNKcEGMRBisQTeT9omMPq0rO9MFv5zIO3AtN5_a1VY_/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/School+Community/Design+for+Change+USA+-+Podcast+-+School+Community+-+Transcript.json"
    },
    {
    "id": 6,
    "name": "School Funding Disparities",
    "short_name": "school_funding",
    "priority": 0,
    "type": "audio",
    "description": "Explore the contrast in school experiences due to funding differences.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/School+Funding+Disparities/Design+for+Change+USA+-+Podcast+-+School+Funding+Disparities+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/School+Funding+Disparities/Design+for+Change+USA+-+Podcast+-+School+Funding+Disparities+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "11 minutes",
    "difficulty": "Advanced",
    "course": "education",
    "global_goal": "Reduced Inequalities",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_10.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/School+Funding+Disparities/Design+for+Change+USA+-+Podcast+-+School+Funding+Disparities+-+Podcast.mp3",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTWWP2GMmSSLBVpP8AgoKrIA2-5-eA5Q4dkPlIBMcwYiLXImyKG19KgoQWbTSavYSPH-ulHpkYbD15G/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/School+Funding+Disparities/Design+for+Change+USA+-+Podcast+-+School+Funding+Disparities+-+Transcript.json"
    },
    {
    "id": 5,
    "name": "Food Waste",
    "short_name": "food_waste",
    "priority": 0,
    "type": "audio",
    "description": "Explore the impact of food waste and learn more about responsible consumption in a school community.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Food+Waste/Design+for+Change+USA+-+Podcast+-+Food+Waste+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Food+Waste/Design+for+Change+USA+-+Podcast+-+Food+Waste+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "9 minutes",
    "difficulty": "Beginner",
    "course": "climate",
    "global_goal": "Responsible Consumption",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_12.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Food+Waste/Design+for+Change+USA+-+Podcast+-+Food+Waste+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vTskV3w0nrmL0OrKEfjgFliYjy9tT_aVR6rl4aANCxNvZEONc0sO6G7Ix5cx3U6Af7F4YIbY9vSzDJk/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Food+Waste/Design+for+Change+USA+-+Podcast+-+Food+Waste+-+Transcript.json"
    },
    {
    "id": 4,
    "name": "Elder Isolation",
    "short_name": "elder_isolation",
    "priority": 0,
    "type": "audio",
    "description": "Explore the challenges that lead to isolation and feelings of loneliness for many elders in our communities as they age. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Elder+Isolation/Design+for+Change+USA+-+Podcast+-+Elder+Isolation+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Elder+Isolation/Design+for+Change+USA+-+Podcast+-+Elder+Isolation+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Good Health and Well-being",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_3.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Elder+Isolation/Design+for+Change+USA+-+Podcast+-+Elder+Isolation+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSTKRpUNeU8aa1I_Ypdz4Aui6SGDpgfLgk3TyITReymUgGXi4dE1ZUmZ2uXF7ewnUjm3HRyKoPEKpDZ/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Elder+Isolation/Design+for+Change+USA+-+Podcast+-+Elder+Isolation+-+Transcript.json"
    },
    {
    "id": 3,
    "name": "Urban Water Contamination",
    "short_name": "water_contamination",
    "priority": 0,
    "type": "audio",
    "description": "Explore the causes of water contamination and the impact of a lack of access to clean water.",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Urban+Water+Contamination/Design+for+Change+USA+-+Podcast+-+Urban+Water+Contamination+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Urban+Water+Contamination/Design+for+Change+USA+-+Podcast+-+Urban+Water+Contamination+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "10 minutes",
    "difficulty": "Advanced",
    "course": "climate",
    "global_goal": "Industry, Innovation and Infrastructure",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_6.png",
    "sponsor_logo": null,
    "sponsor_name": null,
    "sponsor_url": null,
    "url": "https://dfc-podcasts.s3.amazonaws.com/Urban+Water+Contamination/Design+for+Change+USA+-+Podcast+-+Urban+Water+Contamination+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vQ0uovADp5nNW5ITTaFyQbaRxmpksGoTOBY26uSv9PyX32M_ROz4sNhHkWqtXGX03PpgWAlkXIWY908/embed?start=false&loop=false&delayms=600000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Urban+Water+Contamination/Design+for+Change+USA+-+Podcast+-+Urban+Water+Contamination+-+Transcript.json"
    },
    {
    "id": 2,
    "name": "Kinder Communities",
    "short_name": "kinder_communities",
    "priority": 0,
    "type": "audio",
    "description": "Explore the negative outcomes associated with bullying and instances of unkindness in a school community. ",
    "picture": "https://dfc-podcasts.s3.amazonaws.com/Kinder+Communities/Design+for+Change+USA+-+Podcast+-+Kinder+Communities+-+Picture.jpg",
    "picture_large": "https://dfc-podcasts.s3.amazonaws.com/Kinder+Communities/Design+for+Change+USA+-+Podcast+-+Kinder+Communities+-+Picture+-+Large.jpg",
    "published": 1,
    "duration": "9 minutes",
    "difficulty": "Beginner",
    "course": "justice",
    "global_goal": "Peace, Justice and Strong Institutions",
    "global_goal_image": "//pm.designforchange.us/img/global_goals/TheGlobalGoals_Icons_Color_Goal_16.png",
    "sponsor_logo": "//pm.designforchange.us/img/partners/logo_hasbro.png",
    "sponsor_name": "Hasbro",
    "sponsor_url": "https://befearlessbekind.hasbro.com/en-us",
    "url": "https://dfc-podcasts.s3.amazonaws.com/Kinder+Communities/Design+for+Change+USA+-+Podcast+-+Kinder+Communities+-+Podcast.m4a",
    "visuals": "https://docs.google.com/presentation/d/e/2PACX-1vSmqRnQdrAnlL1Xb47aZHw4wUGjKv1upmnWwAxl3cglqlkXuslPnKCCYJ1rJYY5oDeg8lQMdRYpt6an/embed?start=false&loop=false&delayms=6000000",
    "transcript": "https://dfc-podcasts.s3.amazonaws.com/Kinder+Communities/Design+for+Change+USA+-+Podcast+-+Kinder+Communities+-+Transcript.json"
    }
]